export const isKfpReady = () => Boolean(window.kfp?.login_start);
